import React from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { Plus, Minus } from "lucide-react";
import { SERVICES, IMAGES } from "../mock/mock";
import useReveal from "../hooks/useReveal";

function Group({ group }) {
  const defaultVal = `${group.roman}-${group.items[0].num}`;
  return (
    <div className="mb-16 last:mb-0">
      <div className="mb-2 flex items-baseline gap-5 border-b border-[var(--pl-line)] pb-8 md:gap-6">
        <span className="pt-1 font-mono text-sm text-[var(--pl-text)]">{group.roman}</span>
        <h3 className="font-display font-semibold uppercase whitespace-nowrap text-[var(--pl-text)] text-[clamp(1rem,4vw,2.75rem)] leading-[1.02] tracking-[-0.01em]">
          {group.title}
        </h3>
      </div>

      <Accordion.Root type="single" collapsible defaultValue={defaultVal} className="w-full">
        {group.items.map((item) => {
          const value = `${group.roman}-${item.num}`;
          return (
            <Accordion.Item key={value} value={value} className="border-b border-[var(--pl-line)]">
              <Accordion.Header>
                <Accordion.Trigger className="group flex w-full items-center justify-between gap-6 py-5 text-left [&[data-state=open]_.plus]:hidden [&[data-state=closed]_.minus]:hidden">
                  <span className="flex items-baseline gap-5 md:gap-7">
                    <span className="font-mono text-xs text-[var(--pl-text)]">{item.num}</span>
                    <span className="font-display font-medium text-[var(--pl-text)] text-[clamp(1.05rem,1.9vw,1.4rem)] leading-snug tracking-[0] transition-opacity group-hover:opacity-80">
                      {item.title}
                    </span>
                  </span>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center border border-[var(--pl-line-strong)] text-[var(--pl-text)] transition-all duration-300 group-hover:bg-[var(--pl-inverse-bg)] group-hover:text-[var(--pl-inverse-text)]">
                    <Plus className="plus" size={15} strokeWidth={1.5} />
                    <Minus className="minus" size={15} strokeWidth={1.5} />
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up">
                <p className="max-w-2xl pb-7 pl-0 text-[15px] leading-relaxed text-[var(--pl-text-2)] md:pl-[3rem] md:text-[16px]">
                  {item.text}
                </p>
              </Accordion.Content>
            </Accordion.Item>
          );
        })}
      </Accordion.Root>
    </div>
  );
}

export default function Services() {
  const [ref, visible] = useReveal();

  return (
    <section id="servicii" className="theme-light section-pad border-t border-[var(--pl-line)] bg-[var(--pl-bg)] py-24 text-[var(--pl-text)] md:py-36">
      <div className="mb-16 grid grid-cols-1 gap-8 md:mb-24 lg:grid-cols-12">
        <div className="lg:col-span-12">
          <h2 className="font-display font-medium uppercase whitespace-nowrap text-[var(--pl-text)] text-[clamp(1.8rem,7vw,6rem)] leading-none tracking-[-0.02em]">
            SERVICII
          </h2>
        </div>
      </div>

      <div ref={ref} className={`grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16 reveal ${visible ? "is-visible" : ""}`}>
        <div className="lg:col-span-4">
          <div className="overflow-hidden lg:sticky lg:top-28">
            <div className="relative aspect-[3/4] w-full overflow-hidden">
              <img
                src={IMAGES.services}
                alt="Fațadă arhitecturală"
                className="h-full w-full object-cover grayscale contrast-[1.05] transition-transform duration-[1.2s] ease-out hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-[var(--pl-overlay-ring)]" />
            </div>
          </div>
        </div>
        <div className="lg:col-span-8">
          {SERVICES.groups.map((g) => (
            <Group key={g.roman} group={g} />
          ))}
        </div>
      </div>
    </section>
  );
}
